import { Skeleton } from '@material-ui/lab';
import React from 'react';
import styled from 'styled-components';

function ProjectSkeleton() {
  return (
    <StyledProjectSkeleton>
      <StyledSkeleton
        animation="wave"
        variant="rect"
        height={40}
        width={400}
        style={{ marginBottom: 5 }}
      />
      <div className="projectSkeleton__title_box">
        <StyledSkeleton animation="wave" variant="rect" height={80} width={832} />
        <div className="projectSkeleton__button_box">
          <StyledSkeleton animation="wave" variant="rect" height={80} width={400} />
          <StyledSkeleton animation="wave" variant="rect" height={80} width={200} />
        </div>
      </div>
      <StyledSkeleton
        className={'projectSkeleton__content_item teeth'}
        animation="wave"
        variant="rect"
        width="100%"
        height={824}
      />
    </StyledProjectSkeleton>
  );
}

const StyledProjectSkeleton = styled.div`
  padding: 22px 0;
  display: flex;
  flex-direction: column;
  .projectSkeleton__title_box {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    .projectSkeleton__button_box {
      display: flex;
      column-gap: 16px;
    }
  }
  /* .projectSkeleton__content_box {
    height: 824px;
  } */
`;

const StyledSkeleton = styled(Skeleton)`
  border-radius: 5px;
`;

export default ProjectSkeleton;
